module.exports = __webpack_public_path__ + "img/i_c_key_04.bc6a26bf.svg";